/** ========================================================================= *\
 * @prefab PowerbarGroup
 * ========================================================================== */
import * as CONST from 'config';
import Powerbar from './Powerbar'

class PowerbarController extends Phaser.Group {

  /** Class Properties ------------------------------------------------------ */
  powers = [];
  airY = undefined;
  createPower = false;
  timeCreatePow = CONST.LOWCREATEENEMY;

  /** @constructor ---------------------------------------------------------- */
  constructor(game, airY, doggo) {
    super(game);
    this.game = game;
    this.airY = airY;
    this.doggo = doggo;
    this.doggoAlive = true;
    // this.doggo.events.onKilled.add(()=>console.log('not right'))

    game.onLose.add(this.loseGame, this);
  }
  loseGame(){
    this.doggoAlive= false;
  }

  update(){
    if(this.doggoAlive){
      // Create Progress for the game play
      let x = this.game.width;
      let progress = (this.game.progress.toFixed(2) * CONST.MAXSPEED)/100;
      this._createPowers();
      this.x -= CONST.SPEED + progress;
    }
  }

  _createPowers() {
    if(this.createPower)return;

    // create Enemy property
    let enX = this.game.width + -this.x + 300;
    let x = this.game.width;
    let progress = (-(this.x / x)>=CONST.MAXSPEED)?(CONST.MAXSPEED*5):(-(this.x / x)*5).toFixed(2);
    this.timeCreatePow = (Math.floor(Math.random()*CONST.LOWCREATEPOWER)+CONST.MAXCREATEPOWER)

    const power = new Powerbar(this.game, enX, this.airY);
    this.add(power);
    this.powers.push(power);

    // Create random enemy
    // if(Math.random() > 0.8){
    //   const secondEnemy = new Powerbar(this.game, enX + enemy.width + Math.floor(Math.random() * 90) + 1, this.airY);
    //   this.add(secondEnemy);
    //   this.enemies.push(secondEnemy);
    // }

    // Create Enemy timer to reset add enemy boolean
    this.createPower = true;
    const timer = this.game.time.create(this.game, true);
    timer.add(this.timeCreatePow,()=>{
      this.createPower = false;
    });
    timer.start();
  }
}

export default PowerbarController;



// WEBPACK FOOTER //
// ./js/prefabs/PowerbarGroup.js